import React, { useRef, useCallback } from 'react';
import { usePress } from '@react-aria/interactions';
import { Check } from '@beamery/lib-ds-icons';
import { useOption } from '@react-aria/listbox';
import { omit } from '../../utils/index.js';
import { ListBoxItemElement, ListBoxItemLabelElement, ListBoxItemSelectedIconElement, } from './list-box.styles.js';
export function ListBoxNoneItem({ state, listItem, dataAutomation = 'list-item-none', showSelectionCheck = true, }) {
    const ref = useRef(null);
    const { optionProps, isSelected, isFocused, labelProps } = useOption({
        key: listItem.key,
        isSelected: state.selectionManager.isEmpty,
    }, state, ref);
    const onPress = useCallback(() => {
        if (!state.selectionManager.isEmpty) {
            state.selectionManager.clearSelection();
        }
    }, [state.selectionManager.clearSelection, isSelected]);
    const { pressProps } = usePress({ onPress });
    return (React.createElement(ListBoxItemElement, { ...optionProps, ...pressProps, "data-automation": dataAutomation, title: listItem.textValue, isFocused: isFocused, ref: ref },
        React.createElement(ListBoxItemLabelElement, { isSelected: isSelected, ...omit(labelProps, 'color') }, listItem.rendered),
        state.selectionManager.isEmpty && showSelectionCheck ? (React.createElement(ListBoxItemSelectedIconElement, null,
            React.createElement(Check, { color: 'inherit' }))) : null));
}
//# sourceMappingURL=list-box-none-item.component.js.map